import React, { useState } from 'react';
import { useModals } from '../contexts/ModalContext';
import { XIcon, CalendarIcon, UserIcon, MailIcon, MapPinIcon, BriefcaseIcon, CreditCardIcon } from 'lucide-react';
export function GlobalModals() {
  const {
    activeModal,
    closeModal
  } = useModals();
  if (!activeModal) return null;
  return <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-6" data-id="element-62" data-mp="nb4thtg0w0ch">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={closeModal} data-id="element-63" data-mp="3ms2rbwq4i99c"></div>
      
      <div className="relative bg-white rounded-3xl shadow-2xl w-full max-w-lg overflow-hidden animate-fade-in" style={{
      maxHeight: '90vh',
      overflowY: 'auto'
    }} data-id="element-64" data-mp="3rpl5c1izzeo7">
        <button onClick={closeModal} className="absolute top-4 right-4 p-2 bg-gray-100 hover:bg-gray-200 rounded-full text-gray-500 transition-colors z-10" data-id="element-65" data-mp="3vq52h53kmiac">
          <XIcon className="w-5 h-5" data-id="element-66" data-mp="33ypcr26pwffw" />
        </button>

        {activeModal === 'demo' && <DemoModal data-id="element-67" data-mp="380kgedc4f4wu" />}
        {activeModal === 'talent' && <TalentModal data-id="element-68" data-mp="3ksammv8fslyr" />}
        {activeModal === 'rental' && <RentalModal data-id="element-69" data-mp="3kqznx9tum4ei" />}
      </div>
    </div>;
}
function DemoModal() {
  const [submitted, setSubmitted] = useState(false);
  if (submitted) {
    return <div className="p-10 text-center" data-id="element-70" data-mp="3b0xvy6ydk1ub">
        <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-71" data-mp="3azwki1dg5dc2">
          <CalendarIcon className="w-8 h-8" data-id="element-72" data-mp="313tgepz1b4mh" />
        </div>
        <h3 className="text-2xl font-bold text-[#1a2332] mb-3" data-id="element-73" data-mp="315cxgisiljpb">Demo Scheduled!</h3>
        <p className="text-[#5a6a7a]" data-id="element-74" data-mp="2x1f1ggyhkp0h">Check your email for the calendar invite and video link. We look forward to showing you CareNomad Check-Ins™.</p>
      </div>;
  }
  return <div className="p-8 sm:p-10" data-id="element-75" data-mp="2n4tw1uik1bw4">
      <h3 className="text-2xl font-bold text-[#1a2332] mb-2" data-id="element-76" data-mp="2n5v6bwrqxucs">Schedule a Live Demo</h3>
      <p className="text-[#5a6a7a] text-sm mb-8" data-id="element-77" data-mp="qafgzbt7wosg">See how our AI-powered accountability tools can transform your care oversight.</p>
      
      <form onSubmit={e => {
      e.preventDefault();
      setSubmitted(true);
    }} className="space-y-5" data-id="element-78" data-mp="laumpeozt4m2">
        <div data-id="element-79" data-mp="2fr1bjjknoxeh">
          <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-80" data-mp="2kjccmpr4up8m">Full Name</label>
          <div className="relative" data-id="element-81" data-mp="25upuyhe19le8">
            <UserIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-82" data-mp="25vr9ivu9cq0p" />
            <input type="text" required className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#007a87] focus:outline-none" placeholder="Jane Doe" data-id="element-83" data-mp="2auufcii2b09q" />
          </div>
        </div>
        
        <div data-id="element-84" data-mp="33hoxv9vbjpkk">
          <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-85" data-mp="33gds54ibc7qt">Organization Type</label>
          <div className="relative" data-id="element-86" data-mp="2onk2iq9bub8f">
            <BriefcaseIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-87" data-mp="2tjhkf108npnb" />
            <select className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#007a87] focus:outline-none bg-white" data-id="element-88" data-mp="1d5rc1i236f7v">
              <option data-id="element-89" data-mp="1i2r8d194w3ls">Family / Household</option>
              <option data-id="element-90" data-mp="6frnkq4fvpn">Healthcare Facility / Clinic</option>
              <option data-id="element-91" data-mp="3rdsae46nkh7o">Home Care Agency</option>
            </select>
          </div>
        </div>

        <div data-id="element-92" data-mp="3rg60rzqe158w">
          <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-93" data-mp="97x5sxjyxnbp">Work Email</label>
          <div className="relative" data-id="element-94" data-mp="56v326quet4z">
            <MailIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-95" data-mp="57mx3d4skit5" />
            <input type="email" required className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#007a87] focus:outline-none" placeholder="jane@example.com" data-id="element-96" data-mp="3dngd7qv7ns9o" />
          </div>
        </div>

        <div data-id="element-97" data-mp="3mg094jk4biqt">
          <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-98" data-mp="3mgjqnz5uw54b">Preferred Date & Time</label>
          <div className="relative" data-id="element-99" data-mp="3hm5tbr7mvnx0">
            <CalendarIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-100" data-mp="2txmlfcshxd5g" />
            <input type="datetime-local" required className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#007a87] focus:outline-none" data-id="element-101" data-mp="2pvrjc62qqvqm" />
          </div>
        </div>

        <button type="submit" className="w-full bg-[#007a87] hover:bg-[#005c66] text-white font-bold py-3.5 rounded-xl transition-colors mt-2 shadow-md" data-id="element-102" data-mp="37m6e26z6p0wx">
          Confirm Demo
        </button>
      </form>
    </div>;
}
function TalentModal() {
  const [step, setStep] = useState(1);
  return <div className="p-8 sm:p-10" data-id="element-103" data-mp="3m8zlkq2gp2ek">
      <div className="flex justify-between items-center mb-8" data-id="element-104" data-mp="3mc3w056isudo">
        <h3 className="text-2xl font-bold text-[#1a2332]" data-id="element-105" data-mp="3qal5uwhbsiys">Find a Vetted Nanny</h3>
        <span className="text-sm font-bold text-[#007a87] bg-[#007a87]/10 px-3 py-1 rounded-full" data-id="element-106" data-mp="3va7estq4fd1s">Step {step} of 3</span>
      </div>
      
      {step === 1 && <div className="space-y-6 animate-fade-in" data-id="element-107" data-mp="422269vqbwj1">
          <p className="text-[#5a6a7a] font-medium" data-id="element-108" data-mp="20xq0wcr69p9t">What type of care do you need?</p>
          <div className="space-y-3" data-id="element-109" data-mp="25uzodmv03qv0">
            {['Full-Time Nanny', 'Part-Time Nanny', 'Emergency Babysitting', 'Infant Care Specialist'].map(type => <button key={type} onClick={() => setStep(2)} className="w-full text-left px-5 py-4 rounded-xl border-2 border-gray-100 hover:border-[#5a55ea] hover:bg-[#5a55ea]/5 font-semibold text-[#1a2332] transition-all" data-id="element-110" data-mp="1ye35wwa8dcv5">
                {type}
              </button>)}
          </div>
        </div>}

      {step === 2 && <div className="space-y-6 animate-fade-in" data-id="element-111" data-mp="2hbe0i3kx3i49">
          <p className="text-[#5a6a7a] font-medium" data-id="element-112" data-mp="2h8rxmh8z1qsd">Where do you need care?</p>
          <div data-id="element-113" data-mp="2cct0o59kv0gc">
            <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-114" data-mp="2ca6uoa2c4t08">ZIP / Postal Code</label>
            <div className="relative" data-id="element-115" data-mp="27erkpt7g7h93">
              <MapPinIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-116" data-mp="22en4836jimiv" />
              <input type="text" autoFocus className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#5a55ea] focus:outline-none" placeholder="e.g. 27701" data-id="element-117" data-mp="vyuhr12rywsv" />
            </div>
          </div>
          <button onClick={() => setStep(3)} className="w-full bg-[#5a55ea] hover:bg-[#4b47c4] text-white font-bold py-3.5 rounded-xl transition-colors shadow-md" data-id="element-118" data-mp="3f55a3uhbxtcp">
            Continue
          </button>
        </div>}

      {step === 3 && <div className="space-y-6 animate-fade-in text-center py-6" data-id="element-119" data-mp="3a5amq0wrjlwe">
          <div className="w-20 h-20 border-4 border-[#5a55ea] border-t-transparent rounded-full animate-spin mx-auto mb-6" data-id="element-120" data-mp="3a7n7smxticdo"></div>
          <h4 className="text-xl font-bold text-[#1a2332]" data-id="element-121" data-mp="3074mdnqluntn">Matching you with top talent...</h4>
          <p className="text-[#5a6a7a]" data-id="element-122" data-mp="2mg85uv9ydx2y">Scanning our network of CPR-certified, background-checked professionals in your area.</p>
        </div>}
    </div>;
}
function RentalModal() {
  const [submitted, setSubmitted] = useState(false);
  if (submitted) {
    return <div className="p-10 text-center" data-id="element-123" data-mp="2ck4s0s5qoa06">
        <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-124" data-mp="2hh4yv5aexgsc">
          <CheckCircleIcon className="w-8 h-8" data-id="element-125" data-mp="1xvljoadhpv62" />
        </div>
        <h3 className="text-2xl font-bold text-[#1a2332] mb-3" data-id="element-126" data-mp="1ttzxtziza6jq">Order Confirmed!</h3>
        <p className="text-[#5a6a7a]" data-id="element-127" data-mp="27t9c2tnmiql2">Your equipment has been reserved. You will receive a delivery confirmation email shortly.</p>
      </div>;
  }
  return <div className="p-8 sm:p-10" data-id="element-128" data-mp="22sv4tdtujko3">
      <h3 className="text-2xl font-bold text-[#1a2332] mb-2" data-id="element-129" data-mp="2gtxr9ror6wzj">Secure Checkout</h3>
      <p className="text-[#5a6a7a] text-sm mb-8" data-id="element-130" data-mp="2grl2ovohpodi">Complete your reservation for white-glove delivery.</p>
      
      <form onSubmit={e => {
      e.preventDefault();
      setSubmitted(true);
    }} className="space-y-5" data-id="element-131" data-mp="2qjr4sy8ghm6f">
        <div data-id="element-132" data-mp="2lknzdcokddxx">
          <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-133" data-mp="2lkxsh94wo17u">Delivery Address / Hotel Name</label>
          <div className="relative" data-id="element-134" data-mp="30h5aq3wr6skh">
            <MapPinIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-135" data-mp="30i6m69holh2q" />
            <input type="text" required className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#007a87] focus:outline-none" placeholder="123 Main St, Raleigh NC" data-id="element-136" data-mp="2vkokn45zu44r" />
          </div>
        </div>
        
        <div className="grid grid-cols-2 gap-4" data-id="element-137" data-mp="1q4yqxjgn523j">
          <div data-id="element-138" data-mp="1q58fr3py937n">
            <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-139" data-mp="1q2m9r8ipivrj">Start Date</label>
            <input type="date" required className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#007a87] focus:outline-none" data-id="element-140" data-mp="1v1pfywafb813" />
          </div>
          <div data-id="element-141" data-mp="12fwb8h5khjbo">
            <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-142" data-mp="12fe3oodgfiog">End Date</label>
            <input type="date" required className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#007a87] focus:outline-none" data-id="element-143" data-mp="17cwgipulei1q" />
          </div>
        </div>

        <div className="pt-4 border-t border-gray-100" data-id="element-144" data-mp="eoqrvs0f48wm">
          <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-145" data-mp="jod9ser6ydbr">Payment Details</label>
          <div className="relative" data-id="element-146" data-mp="2wymunri7p4ef">
            <CreditCardIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-147" data-mp="2wxlc71yv9fmo" />
            <input type="text" required className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#007a87] focus:outline-none" placeholder="Card Number" data-id="element-148" data-mp="2sxt1ojpwwzeo" />
          </div>
        </div>

        <button type="submit" className="w-full bg-[#1a2332] hover:bg-black text-white font-bold py-3.5 rounded-xl transition-colors mt-4 shadow-md" data-id="element-149" data-mp="2j17vvw62jk9s">
          Pay & Reserve
        </button>
      </form>
    </div>;
}